import { render, staticRenderFns } from "./ProfitLossPortfolioTable.vue?vue&type=template&id=42cce5c6&scoped=true&"
import script from "./ProfitLossPortfolioTable.vue?vue&type=script&lang=js&"
export * from "./ProfitLossPortfolioTable.vue?vue&type=script&lang=js&"
import style0 from "./ProfitLossPortfolioTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProfitLossPortfolioTable.vue?vue&type=style&index=1&id=42cce5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cce5c6",
  null
  
)

export default component.exports